import React, { Suspense } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import routes from "./routes";

const AppRoutes = () => {
  const element = useRoutes(routes);
  return element;
};

const Main = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default Main;
